import * as React from 'react';
export class SelectOption extends React.Component {
    render() {
        const { disabled = false, value, label, ...elemProps } = this.props;
        return (React.createElement("option", Object.assign({ value: value, label: label, disabled: disabled }, elemProps), label));
    }
}
